var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_3362",
    "data-name": "Rettangolo 3362",
    width: 18.114,
    height: 23.975,
    fill: "#a9a9a9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Gas1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gas1",
    clipPath: "url(#clip-Gas1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_35597",
    "data-name": "Raggruppa 35597",
    transform: "translate(4 0.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_32921",
    "data-name": "Raggruppa 32921",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_26732",
    "data-name": "Tracciato 26732",
    d: "M18.114,16.136c0-2.822-2.533-7.873-7.745-15.446a1.6,1.6,0,0,0-2.632,0C2.532,8.264,0,13.317,0,16.136c0,4.378,3.739,7.691,8.745,7.826.087,0,.173.012.262.012h.1c.118,0,.234-.009.351-.017,4.96-.171,8.655-3.471,8.655-7.822M6.434,21.149a3.651,3.651,0,0,1-1.106-2.581c0-.934.659-3.1,3.721-8.042,3.086,4.96,3.738,7.111,3.738,8.032A3.674,3.674,0,0,1,9.15,22.2c-.031,0-.061,0-.093,0H9.039a3.628,3.628,0,0,1-2.605-1.049m7.745-.629a5.469,5.469,0,0,0,.384-1.953c0-1.762-1.319-4.688-4.148-9.207a1.6,1.6,0,0,0-2.712,0c-2.832,4.522-4.151,7.448-4.151,9.219a5.429,5.429,0,0,0,.387,1.946,5.578,5.578,0,0,1-2.163-4.387c0-1.65,1.273-5.466,7.271-14.235,6.021,8.779,7.291,12.586,7.291,14.235a5.576,5.576,0,0,1-2.16,4.385",
    transform: "translate(0 0)",
    fill: "#a9a9a9"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/Gas.f1bd2701d7063232e5b37f6dba2efaca.svg";
export { ForwardRef as ReactComponent };